// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.americanas-page {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px 20px;
    min-height: 80vh;
}

.page-header {
    margin-bottom: 24px;
}

.page-title {
    font-size: 1.75rem;
    font-weight: 800;
    color: var(--brand-primary, #0F172A);
    margin: 0;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 40px;
}

.event-card {
    background-color: var(--bg-card, #fff);
    border-radius: var(--radius-lg, 16px);
    padding: 24px;
    border: 1px solid var(--border-light, #e2e8f0);
    box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05));
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}

.event-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-card, 0 10px 15px -3px rgba(0,0,0,0.1));
    border-color: var(--brand-primary, #0F172A);
}

.event-card.create-card {
    border: 2px dashed var(--border-light, #cbd5e1);
    background-color: transparent;
    align-items: center;
    justify-content: center;
    color: var(--text-muted, #64748b);
    min-height: 180px;
}

.event-card.create-card:hover {
    border-color: var(--brand-accent, #D2F800);
    color: var(--brand-primary, #0F172A);
    background-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
}

.create-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    font-weight: 600;
}

.create-icon {
    font-size: 2.5rem;
    color: var(--brand-accent, #D2F800);
}

.card-header {
    margin-bottom: 16px;
}

.event-name {
    font-size: 1.2rem;
    font-weight: 700;
    color: var(--text-main, #1e293b);
    margin: 0 0 8px 0;
    line-height: 1.3;
}

.event-meta {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 0.9rem;
    color: var(--text-secondary, #64748b);
}

.meta-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.meta-row i {
    width: 20px;
    text-align: center;
    color: var(--brand-primary);
    opacity: 0.7;
}

.spots-badge {
    margin-top: auto;
    align-self: flex-start;
    background-color: var(--bg-app, #f1f5f9);
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--text-main);
}

.archived-section {
    margin-top: 20px;
    border-top: 1px solid var(--border-light, #e2e8f0);
    padding-top: 20px;
}

.toggle-archived-btn {
    background: none;
    border: none;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-muted);
    cursor: pointer;
    padding: 10px 0;
    transition: color 0.2s;
}

.toggle-archived-btn:hover {
    color: var(--brand-primary);
}

.archived-list {
    margin-top: 20px;
    opacity: 0.8;
}

.loading-state, .empty-state {
    text-align: center;
    padding: 40px;
    color: var(--text-muted);
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0,0,0,0.1);
    border-top-color: var(--brand-accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px auto;
}

@keyframes spin { to { transform: rotate(360deg); } }

.alert-banner {
    padding: 12px 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.95rem;
}
.alert-banner.error { background: #FEF2F2; color: #EF4444; border: 1px solid #FECACA; }
.alert-banner.success { background: #DCFCE7; color: #166534; border: 1px solid #BBF7D0; }
.alert-banner.info { background: #EFF6FF; color: #1E40AF; border: 1px solid #BFDBFE; }

@media (max-width: 600px) {
    .cards-grid {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/AmericanasList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,aAAa;IACb,8CAA8C;IAC9C,wDAAwD;IACxD,eAAe;IACf,iDAAiD;IACjD,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,gEAAgE;IAChE,2CAA2C;AAC/C;;AAEA;IACI,+CAA+C;IAC/C,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,oCAAoC;IACpC,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,wCAAwC;IACxC,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kDAAkD;IAClD,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;AACA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACtF,wBAAwB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACxF,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAErF;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".americanas-page {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 30px 20px;\n    min-height: 80vh;\n}\n\n.page-header {\n    margin-bottom: 24px;\n}\n\n.page-title {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: var(--brand-primary, #0F172A);\n    margin: 0;\n}\n\n.cards-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n    margin-bottom: 40px;\n}\n\n.event-card {\n    background-color: var(--bg-card, #fff);\n    border-radius: var(--radius-lg, 16px);\n    padding: 24px;\n    border: 1px solid var(--border-light, #e2e8f0);\n    box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05));\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n}\n\n.event-card:hover {\n    transform: translateY(-4px);\n    box-shadow: var(--shadow-card, 0 10px 15px -3px rgba(0,0,0,0.1));\n    border-color: var(--brand-primary, #0F172A);\n}\n\n.event-card.create-card {\n    border: 2px dashed var(--border-light, #cbd5e1);\n    background-color: transparent;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-muted, #64748b);\n    min-height: 180px;\n}\n\n.event-card.create-card:hover {\n    border-color: var(--brand-accent, #D2F800);\n    color: var(--brand-primary, #0F172A);\n    background-color: rgba(255, 255, 255, 0.5);\n    transform: translateY(-2px);\n}\n\n.create-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    font-weight: 600;\n}\n\n.create-icon {\n    font-size: 2.5rem;\n    color: var(--brand-accent, #D2F800);\n}\n\n.card-header {\n    margin-bottom: 16px;\n}\n\n.event-name {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: var(--text-main, #1e293b);\n    margin: 0 0 8px 0;\n    line-height: 1.3;\n}\n\n.event-meta {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    font-size: 0.9rem;\n    color: var(--text-secondary, #64748b);\n}\n\n.meta-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meta-row i {\n    width: 20px;\n    text-align: center;\n    color: var(--brand-primary);\n    opacity: 0.7;\n}\n\n.spots-badge {\n    margin-top: auto;\n    align-self: flex-start;\n    background-color: var(--bg-app, #f1f5f9);\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.archived-section {\n    margin-top: 20px;\n    border-top: 1px solid var(--border-light, #e2e8f0);\n    padding-top: 20px;\n}\n\n.toggle-archived-btn {\n    background: none;\n    border: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 10px 0;\n    transition: color 0.2s;\n}\n\n.toggle-archived-btn:hover {\n    color: var(--brand-primary);\n}\n\n.archived-list {\n    margin-top: 20px;\n    opacity: 0.8;\n}\n\n.loading-state, .empty-state {\n    text-align: center;\n    padding: 40px;\n    color: var(--text-muted);\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(0,0,0,0.1);\n    border-top-color: var(--brand-accent);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 0 auto 20px auto;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.alert-banner {\n    padding: 12px 20px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 0.95rem;\n}\n.alert-banner.error { background: #FEF2F2; color: #EF4444; border: 1px solid #FECACA; }\n.alert-banner.success { background: #DCFCE7; color: #166534; border: 1px solid #BBF7D0; }\n.alert-banner.info { background: #EFF6FF; color: #1E40AF; border: 1px solid #BFDBFE; }\n\n@media (max-width: 600px) {\n    .cards-grid {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
